/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import { PoolStatusResponse, PoolStatusResponseFromJSON, PoolStatusResponseToJSON } from '../models'

export interface GetUserPoolStatusRequest {
  address?: string
}

/**
 *
 */
export class UserPoolApi extends runtime.BaseAPI {
  /**
   */
  async getUserPoolStatusRaw(
    requestParameters: GetUserPoolStatusRequest,
    initOverrides?: RequestInit,
  ): Promise<runtime.ApiResponse<PoolStatusResponse>> {
    const queryParameters: any = {}

    if (requestParameters.address !== undefined) {
      queryParameters['address'] = requestParameters.address
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/user-pool/status`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => PoolStatusResponseFromJSON(jsonValue))
  }

  /**
   */
  async getUserPoolStatus(
    requestParameters: GetUserPoolStatusRequest = {},
    initOverrides?: RequestInit,
  ): Promise<PoolStatusResponse> {
    const response = await this.getUserPoolStatusRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
